import { TweenMax } from 'gsap';
import Checkbox from './Checkbox.vue';
import DoneButton from './DoneButton.vue';
import Vue from 'vue';
export default Vue.extend({
    components: {
        Checkbox,
        DoneButton
    },
    props: {
        answers: Array,
        numOfAttempts: Number,
        lockedAnswers: {
            type: Array,
            default() {
                return [];
            }
        },
        maxCheckBoxSelections: {
            type: [Number, undefined],
            default: undefined
        },
        resetCheckBoxAfterErrors: {
            type: Boolean,
            default: false
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        showHints: {
            type: Boolean,
            default: false
        },
        showSuccess: {
            type: Boolean,
            default: false
        },
        onSelectDisabledCheckbox: {
            type: Function,
            default: () => null
        }
    },
    data() {
        return {
            selected: [],
            hasBeenSubmitted: false
        };
    },
    computed: {
        correctAnswers() {
            return this.answers.filter(i => i.correct).map(answer => answer.id);
        },
        hasReachedMaxSelections() {
            return this.maxCheckBoxSelections
                ? this.selected.length >= this.maxCheckBoxSelections
                : false;
        }
    },
    watch: {
        numOfAttempts() {
            if (this.numOfAttempts > 2) {
                this.showCorrectAnswers();
            }
        },
        showErrors(newShowErrorsVal, oldShowErrorsVal) {
            if (this.resetCheckBoxAfterErrors && !newShowErrorsVal && oldShowErrorsVal) {
                const selectedIds = this.selected;
                selectedIds.forEach(selectedId => {
                    if (!this.correctAnswers.includes(selectedId)) {
                        this.removeFromSelected(selectedId);
                    }
                });
            }
        }
    },
    methods: {
        getLabel(text, index) {
            const letter = String.fromCharCode(index + 'A'.charCodeAt(0));
            return `${letter}. ${text}`;
        },
        isChecked(id) {
            return this.selected.includes(id);
        },
        isDisabled(answerId) {
            return ((!this.isChecked(answerId) && this.hasReachedMaxSelections) ||
                this.lockedAnswers.includes(answerId));
        },
        addToSelected(id) {
            this.selected = [...this.selected, id];
            this.emitSelectedChanges();
        },
        emitSelectedChanges() {
            this.$emit('onCheckBoxesSelectionChange', this.selected);
        },
        removeFromSelected(id) {
            this.selected = [...this.selected].filter(arrId => arrId !== id);
            this.emitSelectedChanges();
        },
        resetSelected() {
            this.selected = [];
            this.emitSelectedChanges();
        },
        showCorrectAnswers() {
            TweenMax.delayedCall(2.5, () => {
                this.selected = this.correctAnswers;
            });
            TweenMax.delayedCall(4, () => {
                this.resetSelected();
            });
        },
        onSelect(id) {
            if (this.hasBeenSubmitted)
                return;
            const foundSelectedAnswer = this.selected.find(selectedId => selectedId === id);
            const foundAnswer = this.answers.find(answer => answer.id === foundSelectedAnswer);
            if (foundAnswer && foundAnswer.correct && this.hasBeenSubmitted)
                return;
            if (this.isChecked(id)) {
                this.removeFromSelected(id);
                return;
            }
            if (this.selected.length === this.correctAnswers.length)
                return;
            this.addToSelected(id);
        },
        handleOnSelectDisabledCheckbox() {
            this.$emit('onSelectDisabledCheckbox');
        }
    }
});
